import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import { NavLink } from 'react-router-dom'
import { Environment } from '../../environment'
import './WelcomeComponent.scss'

export function WelcomeComponent() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const params = useParams()

  useEffect(() => {
    if (!params.vin) {
      navigate('/')
    }
  }, [navigate, params])

  return (
    <>
      <div className="welcomePage">
        <div className="container">
          <header>
            <img src="../ail-new.svg" width="310" height="185" className="logo" />
            <img src="../ail-new-mobile.svg" width="266" height="57" className="logoMobile" />
          </header>
          <div className="row">
            <div className="col-12 col-md-6 driver">
              <NavLink to={`${Environment.InterfleetDriverUrl}/vin/${params.vin!}`}>
                <div className="box-title">{t('WELCOME_DRIVER')}</div>
                <div className="box">
                  <img src="../4driver.svg" width="303" height="150" />
                </div>
                <div className="box-footer">
                  <img src="../interfleet4driver-logo.svg" width="303" height="58" />
                </div>
              </NavLink>
            </div>
            <div className="col-12 col-md-6 supplier">
              <NavLink to={`/search/${params.vin!}`}>
                <div className="box-title">{t('WELCOME_SUPPLIER')}</div>
                <div className="box">
                  <img src="../ilink.svg" width="313" height="150" />
                </div>
                <div className="box-footer">
                  <img src="../interfleetlink-logo.svg" width="206" height="58" />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
